module.exports = __webpack_public_path__ + "static/img/leftBg.3713feb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/leftBg.png
// module id = 2QTB
// module chunks = 44